import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@mui/styles";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import "react-daterange-picker/dist/css/react-calendar.css";
import CustomerType from '../../common/customer_type';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import '../../assign-prescriptions/index.css';
import moment from 'moment-timezone';
import {withTranslation} from "react-i18next";
import download from '../images/download-doc.svg';
import downloadpdf from '../images/download-pdf.png';
import { IconButton } from "@mui/material";
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  PATIENT_LIST_SORT_MAP,
  applyReportFilterModel,
} from "../../grid/iLocalAGGrid";
import getPatientTypeNameByType from '../../common/getPatientTypeNameByType';
import { ReportToolbar } from "../ReportPageLayout";


class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => event => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {order, orderBy, sortId, className, t} = this.props;
    const rows = [
      { id: "first_name", numeric: false, disablePadding: false, label: t("Report.Patient.FirstName"), padding: '10px', field: 'first_name' },
      { id: "last_name", numeric: false, disablePadding: false, label: t("Report.Patient.LastName"), padding: '10px', field: 'last_name' },
      { id: "member_id", numeric: false, disablePadding: false, label: t("Report.Patient.MemberID"), padding: '10px', field: 'member_id' },
      { id: "drivers_license_no", numeric: false, disablePadding: false, label: t("Report.Patient.DriverLicenceNo"), padding: '10px', field: 'drivers_license_no' },
      { id: "dob", numeric: false, disablePadding: false, label: t("Report.Patient.DOB"), padding: '10px', field: 'dob_str' },
      { id: "email", numeric: false, disablePadding: false, label: t("Report.Patient.Email"), padding: '10px', field: 'email' },
      { id: "phone", numeric: false, disablePadding: false, label: t("Report.Patient.Phone"), padding: '10px', field: 'phone' },
      { id: "name", numeric: false, disablePadding: false, label: t("Report.Patient.Source"), padding: '10px', field: 'name' },
      { id: "enroll_date", numeric: false, disablePadding: false, label: t("Report.Patient.EnrollDateTime"), padding: '10px', field: 'created_on' },
    ];

    return (
      <TableHead>
        <TableRow>
          {rows.map((row, props) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding }}
                className={className.tableCell}>
                {['drivers_license_no'].includes(row.id) ?
                  (<TableSortLabel style={{ cursor: 'text' }} className={className.tableCell}>
                    {row.label}
                  </TableSortLabel>
                  ) : (
                    <Tooltip
                      title={t("Global.Label.Filter.Sort")}
                      placement={row.numeric ? "bottom-end" : "bottom-start"}
                      enterDelay={300}
                      className={className.tableCell}>
                      <TableSortLabel
                        active={orderBy === row.field && sortId === row.id}
                        direction={order}
                        onClick={this.createSortHandler(row.id, row.field)}
                        className={className.tableCell}>
                        {row.label}
                      </TableSortLabel>
                    </Tooltip>
                  )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead)

const styles = theme => ({
  root: {
    width: "100%",
    // marginTop: theme.spacing.unit * 3
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
    // paddingTop:'10%'
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10'
  }
  ,
  padding10px: {
    padding: '10px',
    fontSize: '0.75rem'
  },
  logoWrapper:
  {
    position: 'absolute',
    width: '89%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.5)',
    zIndex: '7869'
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
  hidden: {
    display: 'none'
  },
  tableCell: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.75rem',
    fontWeight: '4500'
  },
});

let FilterObj = {
  searchObject: null,
  searchtext: '',
  CustomerType: CustomerType.Kiosk_Customer,
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  tableName: '',
  group_id: null
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: "desc",
      dob: '',
      orderBy: "created_on",
      page: 0,
      rowsPerPage: 10,
      searchtext: '',
      loader: false,
      isDataEmpty: true,
      totalRecords: 0,
      isButtonDisabled: false,
      queryId: "",
      groups: [],
    };
    this.debouceTimeout = null;
  }

  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === "function") {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === "function") {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    const body = this._agFilterBody;
    if (body && newPageSize && body.pageSize !== newPageSize) {
      body.pageSize = newPageSize;
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this._agFilterBody = FilterObj;
    const datasource = createServerSideDatasource({
      sortMap: PATIENT_LIST_SORT_MAP,
      filterBody: FilterObj,
      applyFilterModel: (body, filterModel) => {
        applyReportFilterModel(body, filterModel);
      },
      pageZeroBased: true,
      getPageSize: () => FilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + 'getkioskcustomer', {
          method: "post",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...body,
            searchtext: body.searchtext || '',
            CustomerType: body.CustomerType || CustomerType.Kiosk_Customer,
          }),
        }).then((r) => r.json()),
      onSuccess: (results, total) => {
        this.setState({
          data: results,
          totalRecords: total,
          loader: false,
          isDataEmpty: !results || results.length === 0,
          isButtonDisabled: !results || results.length === 0,
        });
      },
      onError: () => this.setState({ loader: false }),
    });
    if (typeof params.api.setServerSideDatasource === "function") {
      params.api.setServerSideDatasource(datasource);
    }
  };

  componentDidMount() {
    // Do not reassign pageSize here — changing it after onGridReady remounts
    // SSRM mid-fetch and leaves the grid on Please Wait...
    FilterObj.group_id = sessionStorage.getItem("groupID");
    FilterObj.CustomerType = CustomerType.Kiosk_Customer;
    FilterObj.searchtext = FilterObj.searchtext || '';
    this.fetchSuggestions();
    this.setState({ loader: false });
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }

  formatDob = (value) => {
    if (value == null || value === '') return '';
    const parsed = moment(value);
    if (!parsed.isValid()) return String(value);
    const currentUserLang = localStorage.getItem('i18nextLng');
    return currentUserLang === 'en' ? parsed.format('MM/DD/YYYY') : parsed.format('DD/MM/YYYY');
  };

  csvCell = (value) => `"${String(value == null ? '' : value).replace(/"/g, '""')}"`;

  escapeHtml = (value) => String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  getExportHeaders = () => {
    const {t} = this.props;
    return [
      t("Report.Patient.FirstName"),
      t("Report.Patient.LastName"),
      t("Report.Patient.MemberID"),
      t("Report.Patient.DriverLicenceNo"),
      t("Report.Patient.DOB"),
      t("Report.Patient.Email"),
      t("Report.Patient.Phone"),
      t("Report.Patient.Source"),
      t("Report.Patient.EnrollDateTime"),
    ];
  };

  mapPatientExportRow = (row) => {
    const {t} = this.props;
    return [
      row.first_name || '',
      row.last_name || '',
      row.member_id || '',
      row.drivers_license_no || '',
      this.formatDob(row.dob_str),
      row.email || '',
      row.phone || '',
      getPatientTypeNameByType(row.name, t) || row.name || '',
      row.enroll_date ? this.convertToTimeZone(row.enroll_date) : '',
    ];
  };

  fetchExportData = () => {
    const exportBody = { ...FilterObj };
    delete exportBody.__dateFilterBound;
    delete exportBody.__dateFilterNeedsReseed;
    delete exportBody.__dateFilterColId;
    delete exportBody.__defaultSort;
    return fetch(process.env.REACT_APP_BASEURL + 'CSV/EnrolledPatientReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(exportBody)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((csvData) => (csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : []));
  };

  exportCSV() {
    this.setState({ loader: true });
    this.fetchExportData()
      .then((result) => {
        this.setState({ loader: false });
        if (!result || result.length === 0) return;
        const rows = [this.getExportHeaders(), ...result.map(this.mapPatientExportRow)];
        const csvString = rows.map((row) => row.map(this.csvCell).join(',')).join('\n');
        const element = document.createElement("a");
        element.href = `data:text/csv;charset=utf-8,${encodeURIComponent('\uFEFF' + csvString)}`;
        element.target = "_Blank";
        element.download = "EnrolledPatientsReport.csv";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      })
      .catch(() => this.setState({ loader: false }));
  };

  exportPDF() {
    this.setState({ loader: true });
    this.fetchExportData()
      .then((result) => {
        this.setState({ loader: false });
        if (!result || result.length === 0) return;
        const {t} = this.props;
        const headers = this.getExportHeaders();
        const headerHtml = headers.map((h) => `<th>${this.escapeHtml(h)}</th>`).join('');
        const bodyHtml = result.map((row) => {
          const cells = this.mapPatientExportRow(row)
            .map((cell) => `<td>${this.escapeHtml(cell)}</td>`)
            .join('');
          return `<tr>${cells}</tr>`;
        }).join('');
        const title = t("Report.Patient.PatientListTitle");
        const html = `<!DOCTYPE html><html><head><title>${this.escapeHtml(title)}</title>
          <style>
            @page { size: landscape; margin: 10mm; }
            @media print {
              @page { size: landscape; margin: 10mm; }
              body { padding: 0; }
            }
            body { font-family: Arial, sans-serif; padding: 12px; margin: 0; }
            h2 { margin: 0 0 12px; font-size: 18px; }
            table { border-collapse: collapse; width: 100%; font-size: 11px; table-layout: auto; }
            th, td { border: 1px solid #ccc; padding: 5px 8px; text-align: left; vertical-align: top; white-space: nowrap; }
            th { background: #f5f5f5; }
          </style></head><body>
          <h2>${this.escapeHtml(title)}</h2>
          <table><thead><tr>${headerHtml}</tr></thead><tbody>${bodyHtml}</tbody></table>
          </body></html>`;
        const printWindow = window.open('', 'title', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1400,height=900,left=80,top=40');
        if (!printWindow) return;
        printWindow.document.write(html);
        printWindow.document.close();
        setTimeout(() => {
          printWindow.print();
          printWindow.close();
        }, 1300);
      })
      .catch(() => this.setState({ loader: false }));
  };

  gettingOnSortTableName = (field) => {
    let tablename = '';
    if (['first_name', 'last_name', 'member_id', 'drivers_license_no', 'enroll_date', 'dob'].includes(field)) {
      tablename = 'customers';
    }
    if (['email', 'phone'].includes(field)) {
      tablename = 'contacts';
    }
    if (['name'].includes(field)) {
      tablename = 'customer_type';
    }
    return tablename;
  }

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy, sortId: property });
    FilterObj.sortOrder = order;
    FilterObj.sortColumn = field;
    FilterObj.tableName = this.gettingOnSortTableName(orderBy);

    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();

    FilterObj.pageNo = page;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangeRowsPerPage = event => {

    FilterObj.pageNo = 0;
    FilterObj.pageSize = event.target.value;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };
  //Search Text Box change event
  onSearchChange = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchtext: searchString && searchString });
    FilterObj.pageNo = 0;
    FilterObj.sortOrder = 'desc';
    FilterObj.sortColumn = 'created_on';
    FilterObj.tableName = '';
    FilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindGrid();
    }, 1000)
  }

  BindGrid = () => {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
    // SSRM datasource is attached in onGridReady; avoid a parallel
    // legacy fetch/setState race that leaves the grid on Please Wait...
    this.setState({ loader: false });
  };

  handleInputChange = (event) => {
    this.setState({ queryId: event.target.value });
    FilterObj.group_id = event.target.value
    this.BindGrid();
  };

  fetchSuggestions = async () => {
    try {
      const result = fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      }
      );
      result
        .then((result) => {
          result.json().then((resLocation) => {
            this.setState({ groups: resLocation && resLocation.data })
          })
        })
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  render() {
    const {classes, t} = this.props;

    return (
      <Paper className={classes.root}>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }
        <div>
          <ReportToolbar>
            <Tooltip key="export-csv" title={t("Report.Patient.ExportCSVTooltip")}>
              <span>
                <IconButton
                  style={{ marginRight: '0' }}
                  aria-label="ExportCSV"
                  onClick={() => { this.exportCSV() }}
                  disabled={this.state.isButtonDisabled}>
                  <img alt="download" src={download} style={{ height: '32px', width: '32px', cursor: this.state.isButtonDisabled ? 'default' : 'pointer' }} />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip key="export-pdf" title={t("Report.Patient.ExportPDFTooltip")}>
              <span>
                <IconButton
                  style={{ marginRight: '0' }}
                  aria-label="ExportPDF"
                  onClick={() => { this.exportPDF() }}
                  disabled={this.state.isButtonDisabled}>
                  <img alt="download" src={downloadpdf} style={{ height: '32px', width: '32px', cursor: this.state.isButtonDisabled ? 'default' : 'pointer' }} />
                </IconButton>
              </span>
            </Tooltip>
          </ReportToolbar>

          <div className={classes.tableWrapper}>
          <ILocalAGGrid
            columnDefs={[
              { field: 'first_name', headerName: t("Report.Patient.FirstName"), colId: 'first_name' },
              { field: 'last_name', headerName: t("Report.Patient.LastName"), colId: 'last_name' },
              { field: 'member_id', headerName: t("Report.Patient.MemberID"), colId: 'member_id' },
              { field: 'drivers_license_no', headerName: t("Report.Patient.DriverLicenceNo"), colId: 'drivers_license_no' },
              { field: 'dob_str', headerName: t("Report.Patient.DOB"), colId: 'dob', valueFormatter: (p) => this.formatDob(p.value) },
              { field: 'email', headerName: t("Report.Patient.Email"), colId: 'email' },
              { field: 'phone', headerName: t("Report.Patient.Phone"), colId: 'phone' },
              { field: 'name', headerName: t("Report.Patient.Source"), colId: 'source', valueFormatter: (p) => getPatientTypeNameByType(p.value, t) || p.value || '' },
              { field: 'enroll_date', headerName: t("Report.Patient.EnrollDateTime"), colId: 'enroll_date', valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '' },
            ]}
            defaultColDef={getDefaultColDef()}
            rowModelType="serverSide"
            cacheBlockSize={FilterObj.pageSize || 10}
            paginationPageSize={FilterObj.pageSize || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={40}
            getRowId={(params) => {
              const d = params.data || {};
              return (
                d.id ||
                d.member_id ||
                [d.first_name, d.last_name, d.email, d.phone, d.enroll_date]
                  .filter(Boolean)
                  .join('|') ||
                String(JSON.stringify(d).slice(0, 40))
              );
            }}
            onGridReady={this.onGridReady}
            onPaginationChanged={this.onPaginationChanged}
          />
          </div>
          </div>
      </Paper>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/enrolled-patients/index.js